import { createFileRoute } from "@tanstack/react-router";
import { HowItWorksPage } from "./sa-fungerar-det";

export const Route = createFileRoute("/en/how-it-works")({
  head: () => ({
    meta: [
      { title: "How it works – from photo to published listing | Sellavo" },
      { name: "description", content: "Take a photo or film your item and Sellavo writes the listing for you in seconds." },
      { property: "og:title", content: "How it works – from photo to published listing | Sellavo" },
      { property: "og:description", content: "Take a photo or film your item and Sellavo writes the listing for you in seconds." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/how-it-works" }],
  }),
  component: HowItWorksPage,
});
